export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6484.be166f4c.jpg";